import { action, computed, makeObservable, observable } from 'mobx';
import React, { RefObject } from 'react';
import RootStore from './RootStore';

export default class InquiryPageStore {
  private rootStore: RootStore;

  @observable showNotFoundPage = false;
  @observable showErrorPage = false;
  @observable showOmniErrorPage = false;

  @observable listType: 'inquiry' | 'thread' = 'inquiry';

  @observable isLoadingInquiryData = false;
  @observable isLoadingInquiryCountData = false;
  @observable failedLoadingInquiryData = false;
  @observable isLoadingMessageData = false;
  @observable isLoadingMemoData = false;
  @observable isChangingCompleteStatus = false;

  @observable lastMessageDiv: RefObject<HTMLDivElement> = React.createRef();
  @observable chatInputTextarea: RefObject<HTMLTextAreaElement> =
    React.createRef();
  @observable chatAreaHeight: number = 0;
  @observable chatHeaderAreaHeight: number = 0;
  @observable chatInputAreaHeight: number = 0;

  @observable
  headerInfoDivRef: RefObject<HTMLDivElement> = React.createRef();
  @observable
  autoMessageDivRefForScroll: RefObject<HTMLDivElement> = React.createRef();
  @observable
  messageDivRef: RefObject<HTMLDivElement> = React.createRef();

  @observable showNotFoundContent: boolean = false;
  @observable showMainContainer: boolean = false;

  @computed
  get isStoresReadyToRender(): boolean {
    // FIXME: remove this redundant check...
    return !!this.rootStore.partnerStore;
  }

  @computed
  get chatMessagesAreaHeight(): number {
    return (
      this.chatAreaHeight - this.chatHeaderAreaHeight - this.chatInputAreaHeight
    );
  }

  @action
  setShowOmniErrorPage = (show: boolean) => {
    this.showOmniErrorPage = show;
  };

  @action
  setShowNotFoundPage = (show: boolean) => {
    this.showErrorPage = show;
  };

  @action
  setShowErrorPage = (show: boolean) => {
    this.showErrorPage = show;
  };

  @action
  setIsLoadingInquiryData = (loading: boolean) => {
    this.isLoadingInquiryData = loading;
  };

  @action
  setIsLoadingInquiryCountData = (loading: boolean) => {
    this.isLoadingInquiryCountData = loading;
  };

  @action
  setFailedLoadingInquiryData = (failed: boolean) => {
    this.failedLoadingInquiryData = failed;
  };

  @action
  setIsLoadingMessageData = (loading: boolean) => {
    this.isLoadingMessageData = loading;
  };

  @action
  setIsLoadingMemoData = (loading: boolean) => {
    this.isLoadingMemoData = loading;
  };

  @action
  setIsChangingCompleteStatus = (loading: boolean) => {
    this.isChangingCompleteStatus = loading;
  };

  @action
  setChatAreaHeight = (height: number) => {
    this.chatAreaHeight = height;
  };

  @action
  setChatInputAreaHeight = (height: number) => {
    this.chatInputAreaHeight = height;
  };

  @action
  setChatHeaderAreaHeight = (height: number) => {
    this.chatHeaderAreaHeight = height;
  };

  @action
  lastMessageDivScrollIntoView = (behavior: 'auto' | 'smooth' = 'auto') => {
    if (this.autoMessageDivRefForScroll.current) {
      // during FAQ (auto message)
      this.autoMessageDivRefForScroll.current.scrollIntoView({
        behavior: behavior,
      });
    } else if (this.lastMessageDiv.current) {
      // after / during Inquiry is raised
      this.lastMessageDiv.current.scrollIntoView({
        behavior: behavior,
      });
    }
  };

  @action
  focusChatInput = () => {
    if (this.chatInputTextarea.current) {
      this.chatInputTextarea.current.focus();
    }
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
  }
}
